/** True only when REACT_APP_LSC_ONLY_MODE is exactly "true".
 * When enabled, apex/www serve League Stream Center at root and FI routes redirect.
 * Runtime unset/false stays FI (local default). Production deploys pass true explicitly.
 * Pair with backend LSC_ONLY_MODE for API 410s.
 */
export function isLscOnlyMode(): boolean {
  return process.env.REACT_APP_LSC_ONLY_MODE === 'true';
}

/**
 * Temporary construction gate: Studio is the public landing and LSC is
 * admin-only. Exact "true" enables. Unset/false restores public LSC.
 * Pair with backend LSC_ADMIN_ONLY.
 */
export function isLscAdminOnly(): boolean {
  return process.env.REACT_APP_LSC_ADMIN_ONLY === 'true';
}

/** True only when REACT_APP_MOTION_REVIEW_NOTES_ENABLED is exactly "true". */
export function isMotionReviewNotesEnabled(): boolean {
  return process.env.REACT_APP_MOTION_REVIEW_NOTES_ENABLED === 'true';
}

/**
 * FI Gemini Report Engine v2 (Coach Report). True only when
 * REACT_APP_GEMINI_SCOUTING_REPORT_ENABLED is exactly "true". Default OFF.
 */
export function isGeminiScoutingReportEnabled(): boolean {
  return process.env.REACT_APP_GEMINI_SCOUTING_REPORT_ENABLED === 'true';
}

/** True only when REACT_APP_ENABLE_LSC_BILLING_UI is exactly "true". */
export function isLscBillingUiEnabled(): boolean {
  return process.env.REACT_APP_ENABLE_LSC_BILLING_UI === 'true';
}

/** True only when REACT_APP_LSC_YOUTUBE_OAUTH_ENABLED is exactly "true". Default OFF (dark). */
export function isLscYoutubeOauthEnabled(): boolean {
  return process.env.REACT_APP_LSC_YOUTUBE_OAUTH_ENABLED === 'true';
}

/** True only when REACT_APP_LSC_CFB_DYNASTY_SETUP_ENABLED is exactly "true". */
export function isLscCfbDynastySetupEnabled(): boolean {
  return process.env.REACT_APP_LSC_CFB_DYNASTY_SETUP_ENABLED === 'true';
}

/** True only when REACT_APP_LSC_CFB_VISION_SCHEDULE_INTAKE_ENABLED is exactly "true". */
export function isLscCfbVisionScheduleIntakeEnabled(): boolean {
  return process.env.REACT_APP_LSC_CFB_VISION_SCHEDULE_INTAKE_ENABLED === 'true';
}

/** True only when REACT_APP_LSC_CFB_VOD_SCHEDULE_INTAKE_ENABLED is exactly "true". */
export function isLscCfbVodScheduleIntakeEnabled(): boolean {
  return process.env.REACT_APP_LSC_CFB_VOD_SCHEDULE_INTAKE_ENABLED === 'true';
}

/**
 * Run The Tape Studios (RTTS) master switch.
 * Exact "true" enables; exact "false" disables.
 * When unset: on in local `development`, off everywhere else (test/production).
 * Production Dockerfile defaults the ARG to false.
 */
export function isRttsEnabled(): boolean {
  const raw = process.env.REACT_APP_RTTS_ENABLED;
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return process.env.NODE_ENV === 'development';
}

/**
 * When true (default), RTTS uses the mock data layer.
 * Exact "false" routes through the live client. Unset/other → mock on.
 */
export function isRttsUseMock(): boolean {
  return process.env.REACT_APP_RTTS_USE_MOCK !== 'false';
}

/**
 * Run The Tape Studios standalone B2C surface (`/studio/*`).
 * True only when REACT_APP_RTTS_STUDIO_ENABLED is exactly "true". Default OFF —
 * safe to merge without publicly exposing studio routes.
 */
export function isRttsStudioEnabled(): boolean {
  return process.env.REACT_APP_RTTS_STUDIO_ENABLED === 'true';
}
